exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
exports.i(require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!../styles/utils.scss"), "");
// Module
exports.push([module.id, ".item-group-item-group-2c3YgpQxmwr{padding:8px 0;position:relative}.item-group-item-group-2c3YgpQxmwr:first-child{padding-top:0}.item-group-item-group-2c3YgpQxmwr::before{content:'';position:absolute;top:0;left:8px;right:8px;height:1px;background-color:var(--ui-divider)}@media screen and (-ms-high-contrast: active){.item-group-item-group-2c3YgpQxmwr::before{background-color:windowText}}.item-group-item-group-2c3YgpQxmwr:first-child::before{display:none}.item-group-item-group-2c3YgpQxmwr:last-child{padding-bottom:0}.item-group-with-title-2yZPbg7nmwr{padding-top:16px}.item-group-with-title-2yZPbg7nmwr:first-child{padding-top:4px}.item-group-dark-4Zc6YgcGmwr::before{background-color:rgba(255,255,255,0.1)}.item-group-title-3vP5ySzsmwr{}.item-group-title-3vP5ySzsmwr:empty{display:none}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"item-group": "item-group-item-group-2c3YgpQxmwr",
	"itemGroup": "item-group-item-group-2c3YgpQxmwr",
	"with-title": "item-group-with-title-2yZPbg7nmwr",
	"withTitle": "item-group-with-title-2yZPbg7nmwr",
	"dark": "item-group-dark-4Zc6YgcGmwr",
	"title": "item-group-title-3vP5ySzsmwr " + require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!../styles/utils.scss").locals["padding-list-xs"] + ""
};